module.exports = __webpack_public_path__ + "img/close.11de544c.svg";